import React, { Component } from 'react';
import { connect } from 'react-redux';
import {addMinute, convertFullTime} from '../Core/date';
import TimeLineBlock from './TimeLineBlock';
import TimeLineLabel from './TimeLineLabel';
import { setAppointmentField } from 'jsTheme/Actions/Appointments.action';

const mapStateToProps = (state) => {
    let {selectedTimeline, selectedCalendar, selectedProducts} = state.appointments;
    return {
        selectedTimeline, selectedCalendar, selectedProducts,
        serviceDuration: state.timelines.serviceDuration,
        history: state.history
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setAppointmentField: (list) => dispatch(setAppointmentField(list))
    }
}
class TimeLine extends Component {
    constructor(props){
        super(props);
        ['handleClick','checkBlockIsValid','handleMouseEnter','handleMouseLeave'].forEach(fn => this[fn] = this[fn].bind(this));
        this.state = {
            offsetTooltip: {left: 0, top: 0},
            labelTooltip: '',
            statusTooltip: false
        }    
    }
    componentDidMount(){
        var elHeader = document.getElementsByClassName('content-timeline');
        if(elHeader.length > 0){
            elHeader[0].classList.add('loading');
        }
    }
    checkBlockIsValid(list, time){
        let result = list.find(item => item.time === time);        
        if(typeof (result) === 'undefined') return false
        if(result && result.status != 'OK') return false;
        return true;
    }
    checkBlockIsSelected(time, date){
        let {selectedTimeline, selectedCalendar} = this.props;
        if(selectedTimeline.from !== null && selectedCalendar === date){
            let timeSelected = selectedTimeline.from && selectedTimeline.from;            
            if(time === timeSelected) return true;
        }     
        return false
    }
    handleClick(time, date){ 
        let {serviceDuration, validateComponent, selectedProducts, setAppointmentField} = this.props;        
        let duration = serviceDuration !== '' ? serviceDuration : 0;

        let toTimeClick = addMinute(time, duration);

        if(selectedProducts.length === 0){
            setAppointmentField([{key: 'statusSubmit', value: 'NO PRODUCT'}]);
            return;
        }
        setAppointmentField([
            {key: 'selectedTimeline',value: {from: time, to: toTimeClick}},
            {key: 'selectedCalendar', value: date}
        ]);
        validateComponent && validateComponent(true);          
    }
    handleMouseEnter(e, date, time){
        let {x: left, y: top} = e.target.getBoundingClientRect(),
            newFullDate = convertFullTime(date, time).slice(0, -3); 
        this.setState({
            offsetTooltip: {left,top},
            statusTooltip: true,
            labelTooltip: newFullDate
        })
    }
    handleMouseLeave(){
        this.setState({
            statusTooltip: false
        })
    }
    render() {
        let listBlock = this.props.listBlockTimeLine;    
        let {listTimeLine, history}  = this.props;             
        if(typeof listTimeLine === 'undefined') {            
            return null;
        }
        if(listBlock.length === 0){
            return null;
        }                
        return (
            <div className="timeline-content clearfix">
                <div className="timeline-label timeline-label-prev">
                    {
                        <TimeLineLabel listBlock={listBlock} />
                    }
                </div>
                <div className="timeline-block">
                    {
                        listTimeLine && listTimeLine.map(e => {
                            let stateDate  = e.status,
                                {timeStates} = e; 

                            if(stateDate === 'SHOP_CLOSE'){
                                return <div className='timeline-block-item date-off' key={e.date}></div>
                            }
                            return (
                                <div className='timeline-block-item' key={e.date}>
                                    {
                                        listBlock.map((item, index) => {
                                            let checkSelected = this.checkBlockIsSelected(item, e.date);
                                            let checkStatus = this.checkBlockIsValid(timeStates, item);
                                            return (
                                                <TimeLineBlock 
                                                    key={index} 
                                                    time={item}
                                                    date={e.date}                                                
                                                    checkSelected={checkSelected}
                                                    checkStatus={checkStatus}
                                                    history={history}
                                                    validateComponent={this.props.validateComponent}
                                                    handleClick={this.handleClick}
                                                    handleMouseEnter={this.handleMouseEnter}
                                                    handleMouseLeave={this.handleMouseLeave}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className="timeline-label timeline-label-next">
                    {
                        <TimeLineLabel listBlock={listBlock} />
                    }
                </div>
                <div className="block-tooltip" style={{...this.state.offsetTooltip, display: this.state.statusTooltip ? 'block': 'none'}}>{this.state.labelTooltip}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeLine);
